import ModalContainer from 'components/molecules/ModalContainer';

// components
import IMInventoryEntryForm from 'components/organisms/IMInventoryEntryForm';
interface Props {
  open: boolean;
  onClose(): void;
  productId: number;
  getAllProducts(): void;
  parentId: number;
}

export default function IMInventoryEntry({ open, onClose, productId, getAllProducts, parentId }: Props) {
  return (
    <ModalContainer open={open} title="Entrada de inventario" onClose={onClose}>
      <IMInventoryEntryForm
        productId={productId}
        parentId={parentId}
        getAllProducts={getAllProducts}
        handleCloseModal={onClose}
      />
    </ModalContainer>
  );
}
